var _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedeem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 27,
    height: 27,
    fill: "url(#pattern0_23_296)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_23_296",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_23_296",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_23_296",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADgUlEQVR4nO2cPWsUQRjHN74SCyEIogiCYKXknglnJIWghY0fIJ2gla9YJAi5mQ3cJ0jjazpbLfULWIjRmBQWgmAZSCHEnUlyplDMyiQ5kuzdnvtyPjub+/9gq5s8zzO/THZzM8vjeQAAAAAAAAAAAAAAAAA6EdbPHTKS7mtJH4wSDaNE+M9LCq2VeLIwNtJfFruL9eoRLempUWQSzVGJhlY0Y5S4F96qHsyVvKGqJ42i+YSJWy6txLRXErQS05nnKWmu8XD4RPaVnEPy5sqmn2Hd2+c5jq3RKFrLM1et6FOmlW1vF7kk95hos3nLvJs6uVbiY97EWtJzrwduHWZ7Vc+kTmykWM2RNNCKHpXpYbgwNtKvpXhsH+Q55r2SOnFcsP8yyxLSNT8Q3RmIZgKimYBoJiCaCYhmAqKZgGgmIJoJiGYCopmAaCYgmgmI3ouijRRv2pwyTMXGlGKqNSa9LmVMTtHBRPV09GRcS/odTAiKxvsxSee1ol+R4te0XzlTxpjstw4jabLNankXel5fc0zoeX1GirdtVonfNncJYrKLtqflWtHX6LigJm40x2hFN6Ofa0nfwgdnD7fLXYaY7KI3xvriakuBipaWa8PHTG1wQEvxPfr5shLXOuZ3PGYhoi1aiVdtJvHMnoSbllUiXiapweWYhYleUnTKngJHCv1jL7M7xoodm6QGl2MWJtqi/cp43M+Z5qT8yniaOlyNWajosH75gFH0OXYCUnxJ+9qUqzELFW0J/MolrcR6631QrGufrqQuxNGYhYu2bL3OGl0lL1IX4XDMwkXHrJRgtV45nroIh2M6eo8eupO6AMdjFiq6/dOc5sPR0f2pC3A8ZmGi4/4/NWrows5xG/sJtcGBJDW4HLMw0XHfuKLjliVdz/stzoWYhYjutIewc9xS/eJRo2gx776ECzHZRSfZFWtiX07v1k5b0THZRSfZ57UEcqhiN9u7tXdcdExW0WU5DQnKfsJSmvM9WfIzw17GQDQPEM0ERDMB0UxANBMQzQREMwHRTEA0ExDNBESXUPSu455UV290CQu70hhlq/1a1oQ91SXMbG+9vk+d2PZzy5u455pXqQyvQGwc/Uiag2iRcDWL2cyNBm3TPNvPLcefUk90CdNSzGZuMNjE/pZsPzd7/0nROWzvdwmTYnXTCd3O3TITAAAAAAAAAAAAAAAAvD3PX+BaSMvcKtyRAAAAAElFTkSuQmCC"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeem);
export default __webpack_public_path__ + "static/media/Redeem.0e5c5321960731875bb858f2c65f8686.svg";
export { ForwardRef as ReactComponent };